import type { LowerLetters } from '#types';
import { typeFn } from '#utils/typeFn';

const fn = typeFn<LowerLetters>()();

export default fn;
